.de{aspect-ratio:1/1;}